// tslint:disable: max-line-length
import React from 'react';
import { RouteComponentProps, Redirect } from 'react-router-dom';
import useGetApiData from '../../../../hooks/useGetApiData';
import { Spinner } from 'reactstrap';
import { ConfirmationModel } from '../../../../api/models/rndApplication/ConfirmationModel';
import { PageLayout } from '../../../../components/pageLayout';
import { AlertSuccess } from '../../../../components/alerts';
import styles from './index.module.scss';
import ContentContext from '../../../../components/content/contentContext';

const { confirmArea, confirmWrap, confirmRef, wot, minorHeading, wotNextList, wotWrapper, pageWrapper, pageDetails } = styles;

const convertApplicationYear = (year: string): string => {
    if (year) {
        const parts = year.split('-');
        return `${parts[0]}/${parts[1].substring(2, 4)}`;
    }
    return year;
};

const Confirmation = (props: RouteComponentProps<{ applicationId: string, page?: string }>) => {
    const { match: { params: { applicationId } } } = props;
    const appId = (applicationId && parseInt(applicationId)) || 0;

    const contentData = React.useContext(ContentContext);

    const phoneNumber = contentData && contentData['DepartmentPhone'] && contentData['DepartmentPhone'].inlineContent;

    const departmentName = contentData && contentData['DepartmentName'] && contentData['DepartmentName'].inlineContent;

    if (typeof window !== 'undefined' && document) {
        document.title = 'Application submitted';
    }

    const [applicationLoadState] = useGetApiData<ConfirmationModel | undefined>(`api/application/rnd/${appId}/confirmation`, undefined);
    const { isCalling, data } = applicationLoadState;

    if (applicationId && parseInt(applicationId) && appId.toString() !== applicationId) {
        return <Redirect to='/notfound' />;
    }

    if (isCalling) {
        return <Spinner />;
    }

    if (data && data.status !== 'SubmittedPending') {
        return <Redirect to={`/application/rnd/${appId}`} />;
    }

    const isVariation = (data && data.formSubType === 'Variation') || false;
    const mainMessage = `Your ${isVariation ? 'varied ' : ''}${data && convertApplicationYear(data.applicationYear) ? convertApplicationYear(data.applicationYear) : ''} application to register R&D activities for
        ${data?.companyName ? data.companyName : 'No Name'} has been submitted ${data && data.submittedOn ? ` on ${data.submittedOn}` : ''}`;
    const title = isVariation ? 'Varied application submitted' : 'Application submitted';

    return (
        <div className={pageWrapper}>
            <div className={pageDetails}>
                <PageLayout title={title}>
                    <AlertSuccess>
                        <div className={confirmWrap}>
                            <p className={confirmArea}>
                                {mainMessage}
                            </p>
                            <p className={confirmRef}>
                                {`Your Tracking ID: ${data ? data.referenceNumber : 'Tracking ID not known'}`}
                            </p>
                        </div>
                    </AlertSuccess>
                    <div className={wotWrapper}>
                        <h2 className={minorHeading}>What happens next</h2>
                        <div className={wot}>&nbsp;</div>
                        <p>{`We've received your application at the ${departmentName}.`}</p>
                        <p>
                            This verification does not constitute eligibility.
                            We will contact you either to confirm your registration, or to ask for more information.
                        </p>
                        <h3 className='mb-3'>You can</h3>
                        <ul className={wotNextList}>
                            <li><a href='/landing' className='helpTextLink'>Access and view the status of your existing registration forms</a></li>
                            <li><a href='/landing' className='helpTextLink'>Start a new registration form</a></li>
                            <li>{`Contact us on ${phoneNumber} if you have a problem with your application`}</li>
                        </ul>
                    </div>
                </PageLayout>
            </div>
        </div>
    );
};

export default Confirmation;
